import React from 'react';
import SEO from '../components/SEO';

export default function TermsPage() {
    return (
        <div className="container-page py-12 max-w-4xl text-slate-700 dark:text-slate-300">
            <SEO
                title="Terms & Conditions"
                description="Read the terms and conditions for using AuraIcon AI icon generator service. Learn about credits, usage rights, and refund policies."
                canonical="/terms"
            />
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-8">Terms and Conditions</h1>

            <div className="space-y-8">
                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">1. Acceptance of Terms</h2>
                    <p className="leading-relaxed">
                        By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. In addition, when using this website's particular services, you shall be subject to any posted guidelines or rules applicable to such services.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">2. Service Description</h2>
                    <p className="leading-relaxed">
                        This website provides AI-powered icon generation services. Users can generate icons based on text prompts and purchase them for download.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">3. Intellectual Property Rights</h2>
                    <p className="leading-relaxed">
                        Upon purchase of an icon, Bridge Apps LLC grants you a perpetual, non-exclusive, worldwide license to use, reproduce, display, and distribute the purchased icon for personal and commercial purposes. You retain full ownership rights to the specific icons you purchase. Bridge Apps LLC retains rights to the underlying AI models, generation algorithms, and platform infrastructure.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">4. Credits and Usage</h2>
                    <p className="leading-relaxed mb-4">
                        Our service uses a credit-based system with two types of credits:
                    </p>
                    <ul className="list-disc pl-5 space-y-2 mb-4">
                        <li><strong>Monthly Credits:</strong> Granted to Pro subscribers each billing cycle. These credits expire at the end of each billing period and do not roll over.</li>
                        <li><strong>Top-up Credits:</strong> Purchased as one-time packs or granted as a signup bonus. Top-up credits never expire and remain in your account until used.</li>
                    </ul>
                    <p className="leading-relaxed mb-4">
                        <strong>Credit Consumption Priority:</strong> When you download an icon, the system will consume your Monthly credits first (since they expire). Top-up credits are only used once your Monthly credit balance is zero.
                    </p>
                    <p className="leading-relaxed mb-4">
                        <strong>Generation Limits:</strong>
                    </p>
                    <ul className="list-disc pl-5 space-y-2 mb-4">
                        <li>Free users are limited to 10 icon generations per day.</li>
                        <li>Pro subscribers have unlimited icon generations with no daily limit.</li>
                        <li>Each icon download costs 5 credits, regardless of subscription tier.</li>
                    </ul>
                    <p className="leading-relaxed">
                        <strong>Signup Bonus:</strong> New users receive 20 Top-up credits upon account creation. These credits are non-expiring and can be used at any time.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">5. Payment and Refunds</h2>
                    <p className="leading-relaxed space-y-2">
                        Payment processing services are provided by Paddle. By making a purchase, you agree to Paddle's Consumer Terms and Conditions.
                        <br /><br />
                        <strong>Refund Policy:</strong>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>In accordance with Paddle's Buyer Terms, we offer a 14-day refund policy for all purchases.</li>
                            <li>If you are unsatisfied with your purchase for any reason, you can request a refund within 14 days of the transaction.</li>
                        </ul>
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">6. Limitation of Liability</h2>
                    <p className="leading-relaxed">
                        In no event shall Bridge Apps LLC be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on this website.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">7. Contact Information</h2>
                    <p className="leading-relaxed">
                        If you have any questions about these Terms, please contact us at:
                        <br />
                        <strong>Bridge Apps LLC</strong>
                        <br />
                        82 E 7th Street apt 6
                        <br />
                        New York, NY 10003
                        <br />
                        Email: <a href="mailto:michael@bridgeappsllc.com" className="text-violet-600 dark:text-violet-400 hover:underline">michael@bridgeappsllc.com</a>
                    </p>
                </section>

                <p className="text-sm text-slate-500 mt-12 pt-8 border-t border-slate-200 dark:border-white/10">
                    Last updated: {new Date().toLocaleDateString()}
                </p>
            </div>
        </div>
    );
}
